import $                   from 'jquery';
import React               from 'react';
import ReactDOM            from 'react-dom';
import Reflux              from 'reflux';
import ChoiceActionFactory from './choices/choice-actions-factory';

export default class InputFieldChoice extends React.Component {
  constructor(props) {
    super(props);
    if(props.question.responseText==null){
        props.question.responseText = '';
    }
    this.state = props.question;
    this.ChoiceActions = ChoiceActionFactory.get(props.question.questionId);
  }
  componentDidMount() {
    //this.bindEvents();
  }
  componentDidUpdate(prevProps, prevState) {
    //this.bindEvents();
  }
  bindEvents() {
    let $this = $(ReactDOM.findDOMNode(this));
    let $inputEl = $this.find('input[type="text"]');
    $inputEl.off('change.QNA').on('change.QNA',(e)=>{
      e.preventDefault();
      let el = e.target;
      let value = $.trim(el.value);
      this.props.question.responseText = value;
      this.setState({
          responseText: value
      });
      this.ChoiceActions.change(null,true);
    });
  }
  render() {
      let className = "choice-item input-field-choice";
      let inputId = `input-field-${this.props.question.questionId}`;
      let regex = /[\u3000-\u303F]|[\u3040-\u309F]|[\u30A0-\u30FF]|[\uFF00-\uFFEF]|[\u4E00-\u9FAF]|[\u2605-\u2606]|[\u2190-\u2195]|\u203B/g;
      let inputProps = {
        type: "text",
        name: inputId,
        placeholder: 'Only English Characters Are Valid',
        value: this.state.responseText,
        id: inputId,
        onChange: (e)=>{
          e.preventDefault();
          let el = e.target;
          let value = !regex.test(el.value) ? el.value : '' ;
          this.props.question.responseText = value;
          this.setState({
            responseText: value
          });
          this.ChoiceActions.change(null, true);
        }
      }
      let text = {
        __html: this.state.questionText
      }
      return(
        <ul className="choices-container">
            <li className={className}>
                <label htmlFor={inputId}>
                    <input {...inputProps} />
                </label>
            </li>
        </ul>
      )
    }
}
InputFieldChoice.propTypes={
  question: React.PropTypes.object.isRequired
}
InputFieldChoice.defaultProps={}



// WEBPACK FOOTER //
// ./medscape_modules/qna/form-components/input-field.jsx